import { h, Fragment } from "preact";
import { useState, useRef, useEffect, useContext } from "preact/hooks";
import { IdPrefixContext } from "../../helpers/idPrefixContext";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";

export default function ProductOptionDropdown({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
}) {
  const listBoxRef = useRef(null);
  const idPrefix = useContext(IdPrefixContext);

  const listBoxId = `${idPrefix}-option-listbox-${optionName}`;

  useEffect(() => {
    if (!listBoxRef.current) return;

    const handleListboxChange = (e) => {
      updateOptionValue(e.detail.value);
    };

    listBoxRef.current.addEventListener(
      "aria-listbox:change",
      handleListboxChange,
    );

    return () =>
      listBoxRef.current.removeEventListener(
        "aria-listbox:change",
        handleListboxChange,
      );
  }, [listBoxRef, updateOptionValue]);

  return (
    <div className="product-options__dropdown-wrapper">
      <div className="product-options__name">{optionName}</div>
      <div className="product-options__dropdown">
        <button
          type="button"
          className={`product-options__dropdown-trigger ${disabledOptionValues.includes(selectedOptionValue) ? "product-options__dropdown-trigger--disabled" : ""}`}
          aria-expanded="false"
          aria-haspopup="listbox"
          role="combobox"
          aria-controls={listBoxId}
        >
          <option-popup-trigger data-controls={listBoxId}>
            {sanitizeOptionValue(selectedOptionValue)}
          </option-popup-trigger>
        </button>
        <option-popup
          className="product-options__dropdown-popup"
          data-controlled-by={listBoxId}
          style={{ display: "none" }}
        >
          <aria-listbox
            role="listbox"
            ref={listBoxRef}
            className="product-options__dropdown-listbox"
            id={listBoxId}
          >
            {optionValues.map((optionValue, i) => (
              <button
                type="button"
                key={optionValue.name}
                role="option"
                data-option-index={i}
                data-value={optionValue.name}
                updateOptionValue={updateOptionValue}
                aria-selected={optionValue.name === selectedOptionValue}
                className={`product-options__dropdown-listbox-option ${disabledOptionValues.includes(optionValue.name) ? "product-options__dropdown-listbox-option--disabled" : ""}`}
              >
                {optionValue.name}
              </button>
            ))}
          </aria-listbox>
        </option-popup>
      </div>
    </div>
  );
}
